export default {
  pt: {
    'pedagios.botao': 'Gestão de Pedágios',
    'pedagios.titulo': 'Gestão de Pedágios',
    'pedagios.rota': 'Rota',
    'pedagios.rotaDica': 'Salva nesta Frente ao sair do campo.',
    'pedagios.rotaObrigatoria': 'Preencha a rota para escolher uma opção.',
    'pedagios.rotaSalva': 'Rota salva',
    'pedagios.etapa.opcao': 'Opção',
    'pedagios.etapa.operacao': 'Operação',
    'pedagios.escolhaTitulo': 'O que você quer fazer com os pedágios desta Frente?',
    'pedagios.escolhaDica': 'O Excel vai ao cliente para o VPO, a importação traz o Nº VP de volta e o CSV leva o VPO ao Protheus.',
    'pedagios.opcao.excel': 'Gerar Excel Cliente',
    'pedagios.opcao.excel.dica': 'As viagens de uma data ainda sem Nº VP, na planilha que o cliente preenche.',
    'pedagios.opcao.importar': 'Importar Nº VP HUB',
    'pedagios.opcao.importar.dica': 'A planilha devolvida pelo cliente preenche o Nº VP de cada viagem, pela data e pela placa do cavalo.',
    'pedagios.opcao.csv': 'Gerar CSV',
    'pedagios.opcao.csv.dica': 'O arquivo para importar o VPO no Protheus, com as viagens que ainda não estão Preenchidas.',
    'pedagios.concluir': 'Concluir',
    'pedagios.excel.dica': 'Escolha a data. Entram as viagens desta Frente nessa data com o Nº VP em branco.',
    'pedagios.excel.dia': 'Data das viagens',
    'pedagios.excel.vazio': 'Nenhuma viagem nesta data sem Nº VP.',
    'pedagios.excel.gerar': 'Gerar Excel',
    'pedagios.excel.pronto': 'Excel do cliente baixado.',
    'pedagios.excel.linhas_one': '{{count}} viagem',
    'pedagios.excel.linhas_other': '{{count}} viagens',
    'pedagios.importar.dica': 'Escolha a planilha .xlsx devolvida pelo cliente, no mesmo layout do Excel gerado. Primeiro vem a prévia; nada é gravado antes de confirmar.',
    'pedagios.importar.escolher': 'Escolher planilha',
    'pedagios.importar.outroArquivo': 'Escolher outra planilha',
    'pedagios.importar.linha': 'Linha',
    'pedagios.importar.carga': 'Viagem no HUB',
    'pedagios.importar.situacao': 'Situação',
    'pedagios.importar.status.importada': 'Será importada',
    'pedagios.importar.status.nao_processada': 'Não processada',
    'pedagios.importar.gravada': 'Importada',
    'pedagios.importar.motivo.incompleta': 'Linha sem DATA, PLACA CAVALO ou VPO.',
    'pedagios.importar.motivo.data_invalida': 'A DATA não é uma data.',
    'pedagios.importar.motivo.vpo_invalido': 'O Excel converteu o VPO em número e perdeu dígitos. Formate a coluna como texto e digite de novo.',
    'pedagios.importar.motivo.sem_viagem': 'Nenhuma viagem desta Frente com esta data e esta placa.',
    'pedagios.importar.motivo.mais_de_uma_viagem': 'Mais de uma viagem com esta data e esta placa. Confira e preencha na grade.',
    'pedagios.importar.motivo.ja_preenchida': 'A viagem já tem Nº VP preenchido.',
    'pedagios.importar.motivo.repetida_no_arquivo': 'Outra linha da planilha já casou com esta viagem.',
    'pedagios.importar.vazio': 'A planilha não tem linhas.',
    'pedagios.importar.aImportar_one': '{{count}} a importar',
    'pedagios.importar.aImportar_other': '{{count}} a importar',
    'pedagios.importar.importadas_one': '{{count}} importada',
    'pedagios.importar.importadas_other': '{{count}} importadas',
    'pedagios.importar.naoProcessadas_one': '{{count}} não processada',
    'pedagios.importar.naoProcessadas_other': '{{count}} não processadas',
    'pedagios.importar.confirmar_one': 'Importar {{count}} linha',
    'pedagios.importar.confirmar_other': 'Importar {{count}} linhas',
    'pedagios.importar.concluido': 'Importação concluída. Importadas: {{importadas}}. Não processadas: {{nao}}.',
    'pedagios.csv.dica': 'Entram as viagens desta Frente com STATUS VP diferente de Preenchido que têm Nº VP e viagem do Protheus.',
    'pedagios.csv.foraTitulo': 'Ficaram fora do arquivo',
    'pedagios.csv.semVp_one': '{{count}} viagem sem Nº VP',
    'pedagios.csv.semVp_other': '{{count}} viagens sem Nº VP',
    'pedagios.csv.semViagem_one': '{{count}} viagem sem viagem do Protheus',
    'pedagios.csv.semViagem_other': '{{count}} viagens sem viagem do Protheus',
    'pedagios.csv.semStatus': 'Sem status',
    'pedagios.csv.vazio': 'Nenhuma viagem para o CSV.',
    'pedagios.csv.gerar': 'Gerar CSV',
    'pedagios.csv.pronto': 'CSV do Protheus baixado.',
    'pedagios.csv.linhas_one': '{{count}} linha',
    'pedagios.csv.linhas_other': '{{count}} linhas',
  },
  en: {
    'pedagios.botao': 'Toll management',
    'pedagios.titulo': 'Toll management',
    'pedagios.rota': 'Route',
    'pedagios.rotaDica': 'Saved for this work front when you leave the field.',
    'pedagios.rotaObrigatoria': 'Fill in the route to choose an option.',
    'pedagios.rotaSalva': 'Route saved',
    'pedagios.etapa.opcao': 'Option',
    'pedagios.etapa.operacao': 'Operation',
    'pedagios.escolhaTitulo': 'What do you want to do with the tolls of this work front?',
    'pedagios.escolhaDica': 'The Excel goes to the customer for the VPO, the import brings the VP number back and the CSV takes the VPO to Protheus.',
    'pedagios.opcao.excel': 'Generate customer Excel',
    'pedagios.opcao.excel.dica': 'The trips of a date still without a VP number, in the sheet the customer fills in.',
    'pedagios.opcao.importar': 'Import HUB VP number',
    'pedagios.opcao.importar.dica': 'The sheet returned by the customer fills the VP number of each trip, by date and truck plate.',
    'pedagios.opcao.csv': 'Generate CSV',
    'pedagios.opcao.csv.dica': 'The file to import the VPO into Protheus, with the trips not yet Filled.',
    'pedagios.concluir': 'Finish',
    'pedagios.excel.dica': 'Choose the date. The trips of this work front on that date with an empty VP number are included.',
    'pedagios.excel.dia': 'Trip date',
    'pedagios.excel.vazio': 'No trips on this date without a VP number.',
    'pedagios.excel.gerar': 'Generate Excel',
    'pedagios.excel.pronto': 'Customer Excel downloaded.',
    'pedagios.excel.linhas_one': '{{count}} trip',
    'pedagios.excel.linhas_other': '{{count}} trips',
    'pedagios.importar.dica': 'Choose the .xlsx sheet returned by the customer, in the same layout as the generated Excel. The preview comes first; nothing is saved before you confirm.',
    'pedagios.importar.escolher': 'Choose sheet',
    'pedagios.importar.outroArquivo': 'Choose another sheet',
    'pedagios.importar.linha': 'Row',
    'pedagios.importar.carga': 'Trip in HUB',
    'pedagios.importar.situacao': 'Status',
    'pedagios.importar.status.importada': 'Will be imported',
    'pedagios.importar.status.nao_processada': 'Not processed',
    'pedagios.importar.gravada': 'Imported',
    'pedagios.importar.motivo.incompleta': 'Row without DATA, PLACA CAVALO or VPO.',
    'pedagios.importar.motivo.data_invalida': 'DATA is not a date.',
    'pedagios.importar.motivo.vpo_invalido': 'Excel turned the VPO into a number and lost digits. Format the column as text and type it again.',
    'pedagios.importar.motivo.sem_viagem': 'No trip of this work front with this date and plate.',
    'pedagios.importar.motivo.mais_de_uma_viagem': 'More than one trip with this date and plate. Check and fill in the grid.',
    'pedagios.importar.motivo.ja_preenchida': 'The trip already has a VP number.',
    'pedagios.importar.motivo.repetida_no_arquivo': 'Another row of the sheet already matched this trip.',
    'pedagios.importar.vazio': 'The sheet has no rows.',
    'pedagios.importar.aImportar_one': '{{count}} to import',
    'pedagios.importar.aImportar_other': '{{count}} to import',
    'pedagios.importar.importadas_one': '{{count}} imported',
    'pedagios.importar.importadas_other': '{{count}} imported',
    'pedagios.importar.naoProcessadas_one': '{{count}} not processed',
    'pedagios.importar.naoProcessadas_other': '{{count}} not processed',
    'pedagios.importar.confirmar_one': 'Import {{count}} row',
    'pedagios.importar.confirmar_other': 'Import {{count}} rows',
    'pedagios.importar.concluido': 'Import finished. Imported: {{importadas}}. Not processed: {{nao}}.',
    'pedagios.csv.dica': 'Trips of this work front with a VP status other than Filled that have a VP number and a Protheus trip are included.',
    'pedagios.csv.foraTitulo': 'Left out of the file',
    'pedagios.csv.semVp_one': '{{count}} trip without a VP number',
    'pedagios.csv.semVp_other': '{{count}} trips without a VP number',
    'pedagios.csv.semViagem_one': '{{count}} trip without a Protheus trip',
    'pedagios.csv.semViagem_other': '{{count}} trips without a Protheus trip',
    'pedagios.csv.semStatus': 'No status',
    'pedagios.csv.vazio': 'No trips for the CSV.',
    'pedagios.csv.gerar': 'Generate CSV',
    'pedagios.csv.pronto': 'Protheus CSV downloaded.',
    'pedagios.csv.linhas_one': '{{count}} row',
    'pedagios.csv.linhas_other': '{{count}} rows',
  },
  es: {
    'pedagios.botao': 'Gestión de peajes',
    'pedagios.titulo': 'Gestión de peajes',
    'pedagios.rota': 'Ruta',
    'pedagios.rotaDica': 'Se guarda en este frente al salir del campo.',
    'pedagios.rotaObrigatoria': 'Complete la ruta para elegir una opción.',
    'pedagios.rotaSalva': 'Ruta guardada',
    'pedagios.etapa.opcao': 'Opción',
    'pedagios.etapa.operacao': 'Operación',
    'pedagios.escolhaTitulo': '¿Qué quiere hacer con los peajes de este frente?',
    'pedagios.escolhaDica': 'El Excel va al cliente para el VPO, la importación trae el Nº VP de vuelta y el CSV lleva el VPO al Protheus.',
    'pedagios.opcao.excel': 'Generar Excel del cliente',
    'pedagios.opcao.excel.dica': 'Los viajes de una fecha todavía sin Nº VP, en la planilla que el cliente completa.',
    'pedagios.opcao.importar': 'Importar Nº VP HUB',
    'pedagios.opcao.importar.dica': 'La planilla devuelta por el cliente completa el Nº VP de cada viaje, por la fecha y la placa del tractor.',
    'pedagios.opcao.csv': 'Generar CSV',
    'pedagios.opcao.csv.dica': 'El archivo para importar el VPO en el Protheus, con los viajes que aún no están Completados.',
    'pedagios.concluir': 'Concluir',
    'pedagios.excel.dica': 'Elija la fecha. Entran los viajes de este frente en esa fecha con el Nº VP vacío.',
    'pedagios.excel.dia': 'Fecha de los viajes',
    'pedagios.excel.vazio': 'Ningún viaje en esta fecha sin Nº VP.',
    'pedagios.excel.gerar': 'Generar Excel',
    'pedagios.excel.pronto': 'Excel del cliente descargado.',
    'pedagios.excel.linhas_one': '{{count}} viaje',
    'pedagios.excel.linhas_other': '{{count}} viajes',
    'pedagios.importar.dica': 'Elija la planilla .xlsx devuelta por el cliente, con el mismo diseño del Excel generado. Primero viene la vista previa; nada se guarda antes de confirmar.',
    'pedagios.importar.escolher': 'Elegir planilla',
    'pedagios.importar.outroArquivo': 'Elegir otra planilla',
    'pedagios.importar.linha': 'Línea',
    'pedagios.importar.carga': 'Viaje en el HUB',
    'pedagios.importar.situacao': 'Situación',
    'pedagios.importar.status.importada': 'Se importará',
    'pedagios.importar.status.nao_processada': 'No procesada',
    'pedagios.importar.gravada': 'Importada',
    'pedagios.importar.motivo.incompleta': 'Línea sin DATA, PLACA CAVALO o VPO.',
    'pedagios.importar.motivo.data_invalida': 'La DATA no es una fecha.',
    'pedagios.importar.motivo.vpo_invalido': 'El Excel convirtió el VPO en número y perdió dígitos. Formatee la columna como texto y escríbalo de nuevo.',
    'pedagios.importar.motivo.sem_viagem': 'Ningún viaje de este frente con esta fecha y esta placa.',
    'pedagios.importar.motivo.mais_de_uma_viagem': 'Más de un viaje con esta fecha y esta placa. Verifique y complete en la tabla.',
    'pedagios.importar.motivo.ja_preenchida': 'El viaje ya tiene Nº VP.',
    'pedagios.importar.motivo.repetida_no_arquivo': 'Otra línea de la planilla ya coincidió con este viaje.',
    'pedagios.importar.vazio': 'La planilla no tiene líneas.',
    'pedagios.importar.aImportar_one': '{{count}} para importar',
    'pedagios.importar.aImportar_other': '{{count}} para importar',
    'pedagios.importar.importadas_one': '{{count}} importada',
    'pedagios.importar.importadas_other': '{{count}} importadas',
    'pedagios.importar.naoProcessadas_one': '{{count}} no procesada',
    'pedagios.importar.naoProcessadas_other': '{{count}} no procesadas',
    'pedagios.importar.confirmar_one': 'Importar {{count}} línea',
    'pedagios.importar.confirmar_other': 'Importar {{count}} líneas',
    'pedagios.importar.concluido': 'Importación concluida. Importadas: {{importadas}}. No procesadas: {{nao}}.',
    'pedagios.csv.dica': 'Entran los viajes de este frente con STATUS VP distinto de Completado que tienen Nº VP y viaje del Protheus.',
    'pedagios.csv.foraTitulo': 'Quedaron fuera del archivo',
    'pedagios.csv.semVp_one': '{{count}} viaje sin Nº VP',
    'pedagios.csv.semVp_other': '{{count}} viajes sin Nº VP',
    'pedagios.csv.semViagem_one': '{{count}} viaje sin viaje del Protheus',
    'pedagios.csv.semViagem_other': '{{count}} viajes sin viaje del Protheus',
    'pedagios.csv.semStatus': 'Sin estado',
    'pedagios.csv.vazio': 'Ningún viaje para el CSV.',
    'pedagios.csv.gerar': 'Generar CSV',
    'pedagios.csv.pronto': 'CSV del Protheus descargado.',
    'pedagios.csv.linhas_one': '{{count}} línea',
    'pedagios.csv.linhas_other': '{{count}} líneas',
  },
}
